import React from "react"
import PropTypes from "prop-types"
import { Layout as AntLayout, Button, Space} from "antd"
import { css } from "@emotion/core"
import Colors from "./colors"
import "./layout.css"

export const Header = ({color, bgColor}) => (
  <AntLayout.Header css={css`
    color: ${ color ? color : 'inherit !important'};
    background-color: ${ bgColor ? bgColor : 'inherit'};
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}>
    <Button href="/" type="link"
      css={css`
        text-decoration: none;
        color: inherit !important;
        flex-shrink: 1;
      `}
    >
      Tampa Bay Eats
    </Button>
    <Space
      size="large"
      css={css`
      float: right;
    `}>
      <Button css={css`color: inherit !important;`} type="link" href="/faq">FAQ</Button>
      <Button css={css`color: inherit !important;`} type="link" href="/add">Add a place</Button>
    </Space>
  </AntLayout.Header>
)

const Layout = ({ children, noHeader, headerColor, headerBgColor }) => {
  return (
    <AntLayout css={css`
      color: ${Colors.black};
    `}>
      {!noHeader && <Header color={headerColor} bgColor={headerBgColor}/>}
      <AntLayout.Content css={css`
        min-height: 100vh;
        height: auto;
      `}>
        {children}
      </AntLayout.Content>
      <AntLayout.Footer css={css`
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${ headerColor ? headerColor : Colors.black};
        background-color: ${ headerBgColor ? headerBgColor : 'inherit'};
      `}>
        <div>Made with ❤️ by <a href="https://embarccollective.com" target="_blank" rel="noopener noreferrer">Embarc Collective</a> in Tampa, Florida. Art by <a href="http://www.daveybarnwell.com/" target="_blank" rel="noopener noreferrer">Davey Barnwell</a>. © {new Date().getFullYear()}</div>
      </AntLayout.Footer>
    </AntLayout>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  noHeader: PropTypes.bool,
  headerColor: PropTypes.string,
  headerBgColor: PropTypes.string,
}

export default Layout
